appHost.actions.register({
    // #region Vars
    name: '288a.entity.create',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Entity
        let tEntity = { segments: [] };
        {
            if (params.entity) {
                tEntity = { ...params.entity };
            }
            if (params.domainName) {
                tEntity.domain = params.domainName;
            }
            if (params.namespace) {
                tEntity.namespace = params.namespace;
            }
            if (params.entityName) {
                tEntity.segments = [
                    {
                        name: params.entityName
                    }
                ];
            }
            if (params.fieldName) {
                tEntity.segments.push({
                    name: params.fieldName
                });
            }
        }
        // #endregion
        // #region Args
        let tArgs = {
            entity: tEntity,
            mode: 'create',
            viewName: 'create',
            owner: undefined,
            args: {
                data: data,
                ...params,
            }
        };
        // #endregion
        // #region Debug
        utils.logDebug("action: 288a.entity.create", {
            data: data,
            params: params,
            args: tArgs,
        });
        // #endregion
        // #region Instance
        if (params.__instance && params.__instance.__g_isproxy) {
            tArgs.owner = params.__instance;
        }
        // #endregion
        // #region Special
        let t1 = this.$appHost.entities.getEntityPath(tArgs.entity);
        {
            if (t1 === "web.portal.identity/user") {
                tArgs.entity = {
                    domain: tArgs.entity.domain,
                    namespace: "web.portal.identity",
                    segments: [
                        {
                            "name": "UserCreate"
                        }
                    ]
                };
                //Update
                {
                    t1 = this.$appHost.entities.getEntityPath(tArgs.entity);
                }
            }
            else if (t1 === "web.portal.identity/user/accounts") {
                var tSelection2 = {
                    entity: {
                        domain: tArgs.entity.domain,
                        namespace: "web.portal.identity",
                        segments: [
                            {
                                "name": "account"
                            }
                        ]
                    }
                };
                let tSelection = await this.$appHost.actions.tryExecute('288a.entity.select', data, tSelection2);
                {
                    if (!tSelection.isSucceeded) {
                        return this.Cancel();
                    }
                }
                let tData = null;
                {
                    if (utils.isArray(tSelection.result) && tSelection.result.length > 0) {
                        tData = tSelection.result[0];
                    }
                    else {
                        tData = tSelection.result;
                    }
                    if (!tData) {
                        return this.Cancel();
                    }
                }
                if (tData?.accountID && tArgs.owner) {
                    let tAccounts = tArgs.owner.accounts;
                    {
                        if (tAccounts.some(e => e.accountID === tData?.accountID)) {
                            alert('bereits vorhanden');
                            return this.Cancel();
                        }
                    }
                }
                //Set
                {
                    tArgs.args['$accountID'] = tData?.accountID;
                }
            }
            else if (t1 === "web.portal.identity/account/users") {
                var tSelection2 = {
                    entity: {
                        domain: tArgs.entity.domain,
                        namespace: "web.portal.identity",
                        segments: [
                            {
                                "name": "user"
                            }
                        ]
                    }
                };
                let tSelection = await this.$appHost.actions.tryExecute('288a.entity.select', data, tSelection2);
                {
                    if (!tSelection.isSucceeded) {
                        return this.Cancel();
                    }
                }
                let tData = null;
                {
                    if (utils.isArray(tSelection.result) && tSelection.result.length > 0) {
                        tData = tSelection.result[0];
                    }
                    else {
                        tData = tSelection.result;
                    }
                    if (!tData) {
                        return this.Cancel();
                    }
                }
                if (tData?.userID && tArgs.owner) {
                    let tAccounts = tArgs.owner.users;
                    {
                        if (tAccounts.some(e => e.userID === tData?.userID)) {
                            alert('bereits vorhanden');
                            return this.Cancel();
                        }
                    }
                }
                //Set
                {
                    tArgs.args['$userID'] = tData?.userID;
                }
            }
        }
        // #endregion
        // #region Show
        let tWindow = {
            variant: params?.w ?? 'popup',
            position: params.l,
            size: params.s ?? 'xlarge',
        };
        if (!this.$appHost.notification.hasOpenWindows()) {
            tWindow.variant = "slide";
            tWindow.position = "bottom";
            tWindow.size = "large";
        }
        if (t1 === "web.portal.identity/usercreate") {
            tWindow.variant = "popup";
            tWindow.size = "xlarge";
        }
        //Show
        let tResult = await this.$appHost.notification.showModal2('g-layout__layout-entity', tArgs, tWindow);
        {
            if (tResult.state !== 1) {
                return this.Cancel();
            }
        }
        //Finish
        return this.Ok();
        // #endregion
    },
    // #endregion
});
export {};
